













 





















const node = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "checkinEnabled"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "disableAnonymity"
},
v2 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "settingsId"
},
v3 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "teamHealthEnabled"
},
v4 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "videoMeetingURL"
},
v5 = [
  {
    "kind": "Variable",
    "name": "checkinEnabled",
    "variableName": "checkinEnabled"
  },
  {
    "kind": "Variable",
    "name": "disableAnonymity",
    "variableName": "disableAnonymity"
  },
  {
    "kind": "Variable",
    "name": "settingsId",
    "variableName": "settingsId"
  },
  {
    "kind": "Variable",
    "name": "teamHealthEnabled",
    "variableName": "teamHealthEnabled"
  },
  {
    "kind": "Variable",
    "name": "videoMeetingURL",
    "variableName": "videoMeetingURL"
  }
],
v6 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "phaseTypes",
  "storageKey": null
},
v7 = {
  "kind": "InlineFragment",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "disableAnonymity",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "videoMeetingURL",
      "storageKey": null
    }
  ],
  "type": "RetrospectiveMeetingSettings",
  "abstractKey": null
};
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/),
      (v3/*: any*/),
      (v4/*: any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "SetMeetingSettingsMutation",
    "selections": [
      {
        "alias": null,
        "args": (v5/*: any*/),
        "concreteType": "SetMeetingSettingsPayload",
        "kind": "LinkedField",
        "name": "setMeetingSettings",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": null,
            "kind": "LinkedField",
            "name": "settings",
            "plural": false,
            "selections": [
              (v6/*: any*/),
              (v7/*: any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v2/*: any*/),
      (v0/*: any*/),
      (v3/*: any*/),
      (v1/*: any*/),
      (v4/*: any*/)
    ],
    "kind": "Operation",
    "name": "SetMeetingSettingsMutation",
    "selections": [
      {
        "alias": null,
        "args": (v5/*: any*/),
        "concreteType": "SetMeetingSettingsPayload",
        "kind": "LinkedField",
        "name": "setMeetingSettings",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": null,
            "kind": "LinkedField",
            "name": "settings",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "__typename",
                "storageKey": null
              },
              (v6/*: any*/),
              (v7/*: any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "id",
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "id": "m_KyMjeaJt9NHpGFRodIEwbQ",
    "metadata": {},
    "name": "SetMeetingSettingsMutation",
    "operationKind": "mutation",
    "text": null
  }
};
})();

(node ).hash = "d61e552717d03e126419859ca54ebb03";

export default node;
